<template>
  <div :class="[this.$store.state.isMobile ? 'bottom-nav2' : 'bottom-nav1']" >
    <div class="content" v-show="!this.$store.state.isMobile">
      <div class="left">
        <div class="title">
          <el-image :src="logo" fit="cover" style="width: 8rem"></el-image>
        </div>
        <div class="name">
          <span>山东云大网络科技有限公司</span>
        </div>
        <div class="name">
          <span>山东省东营市东营区南二路233号D栋3楼</span>
        </div>
        <div class="phone">
          <span>400-180-1546</span>
        </div>
        <div class="btn" @click="goDetail(contactPro.pageCategory, contactPro.id)">联系我们</div>
      </div>
      <div class="right">
        <div class="nav-detail">
          <div class="menu-box">
            <div class="menu-list" v-for="(e1, index) in navData" :key="index">
              <div class="menu-title">
                <span>{{ e1.name }}</span>
              </div>
              <div v-if="e1.children && e1.name == '关于云大'">
                <div
                  class="menu-item"
                  v-for="(e2, index) in companyProList"
                  :key="index"
                   @click="goDetail(e2.pageCategory, e2.id)"
                >
                <span>{{ e2.productName }}</span>
                </div>
              </div>
              <div v-if="e1.children && e1.name != '关于云大'">
                <div
                  class="menu-item"
                  v-for="(e2, index) in e1.children"
                  :key="index"
                >
                  <span>{{ e2.name }}</span>
                </div>
              </div>

              <div v-else>
                <div
                  class="menu-item"
                  v-for="(e2, index) in e1.productList"
                  :key="index"
                  @click="goDetail(e2.pageCategory, e2.id)"
                >
                  <span>{{ e2.productName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottoms" v-show="!this.$store.state.isMobile">
      <div class="row">
        <el-image :src="logo" fit="cover" style="width: 4rem"></el-image>
        <span>山东云大网络科技有限公司</span>&nbsp;&nbsp;
        <span @click="openBeiAn" style="cursor: pointer;">鲁ICP备11013030号-3</span>
      </div>
    </div>
    <div class="content2" v-show="this.$store.state.isMobile">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item
          v-for="(e1, index) in navData"
          :key="index"
          :title="e1.name"
          :name="index"
        >
          <!-- <div v-if="e1.children">
            <div
              class="inner-item"
              v-for="(e2, index) in e1.children"
              :key="index"
            >
              <span>{{ e2.name }}</span>
            </div>
          </div> -->
          <div v-if="e1.children && e1.name == '关于云大'">
            <div
              class="inner-item"
              v-for="(e2, index) in companyProList"
              :key="index"
                @click="goDetail(e2.pageCategory, e2.id)"
            >
            <span>{{ e2.productName }}</span>
            </div>
          </div>
          <div v-if="e1.children && e1.name != '关于云大'">
            <div
              class="inner-item"
              v-for="(e2, index) in e1.children"
              :key="index"
            >
              <span>{{ e2.name }}</span>
            </div>
          </div>


          <div v-else>
            <div
              class="inner-item"
              v-for="(e2, index) in e1.productList"
              :key="index"
              @click="goDetail(e2.pageCategory, e2.id)"
            >
              <span>{{ e2.productName }}</span>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
  <script>
import { getNavigationBarData,getListIds } from "@/api/front";
export default {
  props: {
    siteId: null,
  },
  data() {
    return {
      logo: require("@/assets/yunda2-old.png"),
      navData: this.$store.state.navList,
      menuList: [],
      activeName: "",
      isLoading: false,
      companyProList:[],
      contactPro:{},
      newsEventsListId: '',
      officialWebsiteListId: ''
    };
  },

  created() {
    this.getKey();
    this.getNavList();
    this.dealNav()
  },
  methods: {
    dealNav(){
      this.companyProList = []
      this.navData.forEach((e,index) => {
        if(e.name == '关于云大'){
          e.children.forEach((e1)=>{
            this.companyProList.push(...e1.productList)
          })
          this.getContact();
        }
      })
    },
    openBeiAn() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    getContact(){
      this.contactPro = this.companyProList.find(e => e.productName == '联系我们');
      
    },
    getNavList() {
      this.isLoading = true
      getNavigationBarData().then((res) => {
        let data = res.data.filter((e) => e.name !== "首页");
        this.navData = this.handleTree(data);
        this.isLoading = false
      });
    },
    getKey() {
      getListIds().then(res => {
        this.newsEventsListId = res.data.newsEventsListId;
        this.officialWebsiteListId = res.data.officialWebsiteListId;

      })
    },
    goDetail(type, id) {
      if (this.currentIndex == this.navData.length - 1) {
        return;
      } else {
        let path = "";
        if (id == this.newsEventsListId ) {
          path='dynamic-list';
          let routerJump = this.$router.resolve({
            path: path,
            query: { category: '0' },
            
          });
          window.open(routerJump.href, "_blank");
        }else if(id == this.officialWebsiteListId){
          path='tech-list';
          let routerJump = this.$router.resolve({
            path: path,            
          });
          window.open(routerJump.href, "_blank");
        } else {
          if (type == 0) {
            path = "/product-detail";
          } else {
            path = "/article-detail";
          }
          let routerJump = this.$router.resolve({
            path: path,
            query: { id: id, category: type },
          });
          window.open(routerJump.href, "_blank");
        }
      }
    },
  },
};
</script>
  <style lang="scss">
.bottom-nav1 {
  width: 100%;
  height: 30rem;
  background-color: rgb(233, 237, 239);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 10rem;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
}
.bottom-nav2 {
  width: 100%;
  background-color: rgb(232, 232, 232);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem 1.5rem;
  box-sizing: border-box;
}
.content {
  margin: 0 auto;
  width: 100%;
  display: flex;
  // height: 20rem;
  box-sizing: border-box;
  .left {
    width: 30%;
    text-align: left;
    font-size: 1rem;
    .title {
      margin: 2.5rem 0 1rem;
      display: flex;
      flex-direction: column;
    }
    .name {
      margin-top: 1rem;
    }
    .phone {
      font-size: 2rem;
      font-weight: 600;
      margin-top: 2.5rem;
    }
    .btn {
      cursor: pointer;
      margin-top: 1.5rem;
      width: 8.5rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgb(146, 165, 182);
      color: #fff;
      font-size: 1rem;
    }
  }
  .right {
    width: 70%;
    margin-top: 2.5rem;
    display: flex;
    justify-content: flex-end;
    .nav-detail {
      // min-height: 300px;
      width: 100%;

      .menu-box {
        width: 100%;
        height: 100%;
        // padding: 40px 80px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .menu-list {
          text-align: left;
          // width: 20%;
          flex: 1;
          margin-left: 2.5rem;
          .menu-title {
            border-bottom: 1px solid #e7e7e7;
            line-height: 3rem;
            font-size: 1.5rem;
            font-weight: 500;
          }
          .menu-item {
            line-height: 2.5rem;
            color: #656565;
            span {
              &:hover {
                cursor: pointer;
                color: #000;
              }
            }
          }
        }
      }
    }
  }
}
.bottoms {
  border-top: 1px solid #ddd;
  padding: 1.5rem 0 3rem;
  margin-top: 1.5rem;
  width: 100%;
  .row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .el-image {
      margin-right: 0.8rem;
    }
  }
}
.content2 {
  min-height: 17rem;
  width: 100%;
  .inner-item {
    // width: 80%;
    padding: 0.5rem 1rem;
    text-align: left;
  }
  .el-collapse {
    border: none;
  }
  .el-collapse-item__header {
    background-color: transparent;
    font-size: 1rem;
    border-bottom: 0.1rem solid #ddd;
    height: 4rem;
  }
  .el-collapse-item__wrap {
    background-color: transparent;
    border: none;
  }
  .el-collapse-item__content {
    font-size: 1rem;
  }
}
</style>